module.exports = __webpack_public_path__ + "static/img/new-img02.afab3546.webp";